var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Images_Anime",
    "data-name": "Images/Anime",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.276,
    height: 30,
    viewBox: "0 0 29.276 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "anime3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Mask",
    cx: 14.638,
    cy: 15,
    rx: 14.638,
    ry: 15,
    fill: "#1e1e24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons_16px_white_single_",
    "data-name": "Icons/16px/white/single ",
    transform: "translate(8.12 7.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons_16px_primary_single",
    "data-name": "icons/16px/primary/single",
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "single-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M8,0H5A5,5,0,0,0,0,5H13A5,5,0,0,0,8,0Z",
    transform: "translate(0.5 10.5)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(3.5 0.5)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default-avatar.71c8a323b5aba98b0dd29d5dae11c7e7.svg";
export { ForwardRef as ReactComponent };